import { Tooltip } from "@mui/material";
import React from "react";

const CustomTooltip = ({ children, sliceLength, cutOffAfter, toolTipContent = '', forceTooltip = false }) => {
  const isTextCutoff = children?.length > sliceLength;
  const displayName = isTextCutoff
    ? children.slice(0, cutOffAfter) + "..."
    : children;

  return (isTextCutoff || forceTooltip) ? (
    <Tooltip
      title={
        <span
          style={{
            color: "black",
          }}
          className={`flex items-center rounded-md text-xs p-2`}
        >
          {toolTipContent || children}
        </span>
      }
      arrow
      placement="bottom"
      PopperProps={{
        style: {
          backgroundColor: "transparent",
          color: "black",
        },
      }}
      classes={{
        tooltip: "custom-tooltip",
      }}
    >
      <span className={`flex m-margin-0.10rem items-center rounded-md`}>
        {displayName}
      </span>
    </Tooltip>
  ) : (
    <span className={`flex m-margin-0.10rem items-center rounded-md`}>
      {displayName}
    </span>
  );
};

export default CustomTooltip;
